import { render, staticRenderFns } from "./submitOrder.vue?vue&type=template&id=ef21470e&scoped=true&"
import script from "./submitOrder.vue?vue&type=script&lang=js&"
export * from "./submitOrder.vue?vue&type=script&lang=js&"
import style0 from "./submitOrder.vue?vue&type=style&index=0&id=ef21470e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef21470e",
  null
  
)

export default component.exports